import {createContext} from 'react';

const buscadorContext = createContext();

export default buscadorContext;